export const UnitDispatchType = {
  Generator: "Generator",
  Load: "Load"
};
